import React, { FunctionComponent, lazy, Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { LMIPRO_VIEW_PATHS, VIEW_PATH } from '@common/constants'
import { LoadingSpinner } from '@common/components'
import { useLanguageInPathName } from '@common/hooks/useLanguageInPathName'

// Import the page views
const Billing = lazy(() => import('./views/Billing'))
const ErrorView = lazy(() => import('@common/components/ErrorView'))

export const LmiProRoutes: FunctionComponent = () => {
    const { search, hash } = window.location
    useLanguageInPathName()

    return (
        <Suspense fallback={<LoadingSpinner />}>
            <Routes>
                {/* error page */}
                <Route
                    path={VIEW_PATH.PATH_ERROR}
                    element={
                        <ErrorView>
                            Something went wrong! Please try again. If you're still experiencing problems please call us
                            at 1 866 890 8931.
                        </ErrorView>
                    }
                />

                {/* billing main page with customize */}
                {/*
                <Route path={`${VIEW_PATH.PATH_CUSTOMIZE}/:plan`} element={<Billing step="customize" />} />
                <Route path={VIEW_PATH.PATH_CUSTOMIZE} element={<Billing step="customize" />} />
                */}

                {/* billing main page with checkout */}
                <Route path={`${VIEW_PATH.PATH_CHECKOUT}/:plan`} element={<Billing step="checkout" />} />
                <Route path={VIEW_PATH.PATH_CHECKOUT} element={<Billing step="checkout" />} />

                {/* fallback */}
                <Route
                    path="/*"
                    element={
                        <Navigate
                            to={{
                                pathname: LMIPRO_VIEW_PATHS.LMIPRO_CHECKOUT,
                                search,
                                hash,
                            }}
                        />
                    }
                />
            </Routes>
        </Suspense>
    )
}
